"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
function buildElement(tag, text, options) {
    if (options === void 0) { options = {}; }
    var element = document.createElement(tag);
    var textNode = document.createTextNode(text);
    element.appendChild(textNode);
    Object.keys(options)
        .forEach(function (key) { return element.setAttribute(key, options[key]); });
    return element.outerHTML;
}
exports.buildElement = buildElement;
function translateElement(tag, translationKey, options) {
    if (options === void 0) { options = {}; }
    var text = I18n.t(translationKey);
    return buildElement(tag, text, options);
}
exports.translateElement = translateElement;
//# sourceMappingURL=html_translation.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/html_translation.js
// module id = 8VnQ
// module chunks = 20 21